import { render, staticRenderFns } from "./EntityTypeItemsPage.vue?vue&type=template&id=318cb77e&"
import script from "./EntityTypeItemsPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EntityTypeItemsPage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports